import { render, staticRenderFns } from "./CalendarPage.vue?vue&type=template&id=4894ba5c&scoped=true"
import script from "./CalendarPage.vue?vue&type=script&lang=js"
export * from "./CalendarPage.vue?vue&type=script&lang=js"
import style0 from "./CalendarPage.vue?vue&type=style&index=0&id=4894ba5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894ba5c",
  null
  
)

export default component.exports